import { useLanguage } from "../LanguageContext";

export default function Disclaimer({ className = "" }) {
  const { t } = useLanguage();
  return (
    <div className={`flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3 text-sm text-stone-700 ${className}`}>
      <svg className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
      <p>
        <strong className="text-stone-800">{t.disclaimer.title}</strong>{" "}
        {t.disclaimer.body}
      </p>
    </div>
  );
}
